import React, {useEffect, useRef} from 'react';
import styles from './Checkbox.module.scss';
import cn from 'classnames';

export interface ICheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  label?: string;
  className?: string;
  name?: string;
  title?: string;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  autoFocus?: boolean;
}
export const Checkbox: (props: ICheckboxProps) => JSX.Element = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (props.autoFocus && inputRef.current) inputRef.current.focus();
  }, [props.autoFocus]);
  return (
    <div
      className={cn(
        styles.root,
        props.className,
        props.size && styles[`input--${props.size}`],
      )}>
      <input
        ref={inputRef}
        type={'checkbox'}
        checked={props.value}
        name={props.name}
        title={props.title}
        aria-label={props.title || props.name}
        onChange={(e) => {
          props.onChange(!props.value);
        }}
        disabled={props.disabled}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
      {props.label && <label>{props.label}</label>}
    </div>
  );
};
